module.exports = __webpack_public_path__ + "img/QU.45fa1146.jpg";